
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Control, FieldPath } from "react-hook-form";
import { CharacterFormData } from "../validation/characterSchema";
import { generateGradientColors } from "@/utils/colorUtils";

interface Option {
  value: string;
  label: string;
  color?: string;
}

interface CharacterFieldSelectProps {
  control: Control<CharacterFormData>;
  name: FieldPath<CharacterFormData>;
  label: string;
  placeholder: string;
  options: Option[];
  isLoading?: boolean;
  showColorDot?: boolean;
}

export const CharacterFieldSelect = ({ 
  control, 
  name, 
  label, 
  placeholder, 
  options, 
  isLoading = false,
  showColorDot = false
}: CharacterFieldSelectProps) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            value={field.value ? String(field.value) : ""}
            disabled={isLoading}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={isLoading ? "Loading..." : placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {options.map((option) => {
                const gradientColors = option.color ? generateGradientColors(option.color) : null;
                
                return (
                  <SelectItem key={option.value} value={option.value}>
                    <div className="flex items-center gap-2">
                      {showColorDot && option.color && (
                        <div 
                          className="w-4 h-4 rounded-full border border-gray-200"
                          style={{ 
                            background: gradientColors 
                              ? `linear-gradient(45deg, ${gradientColors.from}, ${gradientColors.to})`
                              : option.color 
                          }}
                        />
                      )}
                      {option.label}
                    </div>
                  </SelectItem>
                );
              })}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
